export default __webpack_public_path__ + "static/media/reviews2.c7e9ce02.jpeg";